// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.leftBottom[data-v-6454783c] {\n  position: fixed;\n  left: 5px;\n  bottom: 5px;\n  opacity: 0.3;\n}\n@media only screen and (max-width: 1000px) {\n.leftBottom[data-v-6454783c] {\n    display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
